import styled from 'styled-components';
import {
  lighten,
} from 'polished';
import {
  Flex,
} from 'web-styled';

export const CalendarContainer = styled(Flex).attrs({
  fillSpace: true,
})`
  .rbc-row {
    height: 17px;
  }
  .rbc-today {
    background-color: ${props => lighten(0.3, props.theme.colors.primary)};
  }
`;
